<script>
export default defineComponent({
  props: {
    size: {
      type: [Number, String],
      default: '24px',
    }
  },

  computed: {
    normalizedSize() {
      if (typeof this.size === 'number' || Number.isInteger(this.size)) {
        return `${this.size}px`;
      }

      return this.size;
    }
  }
});
</script>

<template>
  <BaseIcon :width="normalizedSize" :height="normalizedSize" class="spinner-animation" name="loadericon" />
</template>
